// extracted by mini-css-extract-plugin
export default {"dark":"Efhqj_","light":"WU06RX"};